export default {
  path: '/articles',
  name: 'articles',
  component: () => import('../components/article/Layout'),
  redirect: { name: 'ArticleList' },
  meta: {
    breadcrumb: 'article.articles',
  },
  children: [
    {
      name: 'ArticleList',
      path: '',
      component: () => import('../views/article/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ArticleCreate',
      path: 'new',
      component: () => import('../views/article/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ArticleUpdate',
      path: ':id/edit',
      component: () => import('../views/article/Update'),
      meta: {
        breadcrumb: 'article.article',
      },
    },
    {
      name: 'ArticleShowLink',
      path: ':id/link',
      component: () => import('../views/article/ShowLink'),
      meta: {
        breadcrumb: 'article.article',
      },
    },
    {
      name: 'ArticleShow',
      path: ':id',
      component: () => import('../views/article/Show'),
      meta: {
        breadcrumb: 'article.article',
      },
    },

  ]
};
